import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import ProfileLayout from 'src/app/layouts/ProfileLayout';
import { AppRoutes } from 'src/app/navigation/routes';
import { DocumentViewerUI, CsvViewerUI, HeicViewerUI, GoogleDocsViewer }  from './index';

const DocumentViewer = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const { docs, headerTitle } = location.state || {};

  useEffect(() => {
    if(!docs || !docs?.length) navigate(AppRoutes.HOME);
  }, [docs])

  const isHeic = (ext: string) => ['heic', 'heif'].includes(ext);
  const isDocOrTxt = (ext: string) => ['doc', 'docx', 'txt', 'ppt', 'pptx'].includes(ext);
  const isCSV = (ext: string) => ext === 'csv';

  const documentRenderer = () => {
    const firstDoc = docs?.[0];
    const ext = firstDoc?.uri?.split('.').pop()?.toLowerCase();

    switch(true){
      case isHeic(ext) :
        return <HeicViewerUI docs={docs}/>
      case isDocOrTxt(ext) :
        return <GoogleDocsViewer docs={docs} />
      case isCSV(ext) :
        return <CsvViewerUI docs={docs} />
      default :
        return <DocumentViewerUI docs={docs} />
    }
  }
  

  return (
    <ProfileLayout title={headerTitle}>
      <div className="react-doc-viewer">
        {docs?.length ? documentRenderer() : null}
      </div>
    </ProfileLayout>
  )
}

export default DocumentViewer;